import React, { useLayoutEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import Button from '../../../../generic-components/Button';
import { useStore } from '../../../../store';
import { BACK_BUTTON_STYLE } from '../../constants';
import arrow from '../../../../assets/svg/backArrow.svg';
import Icon from '../../../../generic-components/Icon';
import { useLogoutQuery } from '../../../../hooks/query/useLogoutQuery';

interface IProps {
    children: React.ReactNode;
    backButton?: boolean;
    backDestination?: number;
    backButtonDestination?: string;
    shouldLogOutOnBack?: boolean;
}

const LoginLayout = ({
  backButton, children, backDestination, backButtonDestination, shouldLogOutOnBack,
}: IProps) => {
  const setCurrentPage = useStore(state => state.setCurrentPage);
  const { user: { customerId } } = useStore(state => state);
  const navigate = useNavigate();
  const { refetch: LogOut } = useLogoutQuery({
    customerId,
    stepToShow: 4,

  });

  useLayoutEffect(() => {
    if (shouldLogOutOnBack) {
      LogOut();
    }
  }, []);

  const handleClick = async () => {
    if (shouldLogOutOnBack) {
      await LogOut();
    } else if (backButtonDestination) {
      navigate(backButtonDestination);
    } else if (backDestination !== undefined) {
      setCurrentPage(backDestination);
    }
  };

  return (
    <div className='bg-bw02 h-screen m-screen m-auto flex'>
      {backButton ? <Button id='backButton' onClick={handleClick} childElement={<Icon src={arrow} />} title='' className={BACK_BUTTON_STYLE.CLASS_NAME} /> : []}
      {children}
    </div>
  );
};

export default LoginLayout;
